import api from "@/api/index";
import {
  IsIsNullOrEmpty,
  getLocalStorage,
  getMSALInfo,
  setLocalStorage,
} from "@/utilities/common";
export const customrOption = {
  Events: {},
  getCustomers: (searchValue?: any) => {
    if (getLocalStorage("customers") === null) return {};
    if (IsIsNullOrEmpty(searchValue)) {
      return JSON.parse(getLocalStorage("customers") || "{}");
    } else {
      return JSON.parse(getLocalStorage("customers") || "{}").customers.filter(
        (val: any) => `${val.customerName}_${val.customerNumber}`.toUpperCase().indexOf(searchValue.toUpperCase()) !== -1
      );
    }
  },
  getCIDList: (setMenuItems: any) => {
    api.Customer.CIDlist({
      email: getMSALInfo()?.accountUsername,
    }).then((res: any) => {
      setMenuItems(res);
      setLocalStorage("customers", res);
    });
  },
  getAccount: (searchValue?: string) => {
    const accountList = JSON.parse(getLocalStorage("accounts") as string);
    if (IsIsNullOrEmpty(searchValue)) {
      return accountList;
    } else {
      return accountList.accounts.filter(
        (val: any) => val.accountName.toUpperCase().indexOf(searchValue?.toUpperCase()) !== -1 || val.accountNumber.toUpperCase().indexOf(searchValue?.toUpperCase()) !== -1
      );
    }
  },
};
